//存放所有接口时间,包括startTime,endTime,duration,name
let apiTimes = {}
//配置存放需要上报的接口,本JS 其他代码不用改动
let targetApi = [
  '/activity/conf', //conf aid信息查询
]

var apiPostData = function(state, name) {
  apiTimes[name].endTime = new Date().getTime()
  if (window.MgStat && MgStat.send) {
    let apiData = {
      st: apiTimes[name].duration,
      sc: state,
      url: name,
    }
    MgStat.send('error', apiData, { code: '310672' })
  }
}
export default {
  /**
   * 设置接口调用时间
   * @param name 接口名称
   */
  setApiTime(name) {
    if (typeof name !== 'string') {
      return false
    }
    if (targetApi.indexOf(name) == -1) {
      return false
    }
    apiTimes[name] = {}
    apiTimes[name].startTime = new Date().getTime()
    apiTimes[name].name = name
  },
  /**
   * 上报接口持续时间
   * @param name 接口名称
   * @param resp 接口状态
   */
  reportApiResult(name, state) {
    if (typeof name !== 'string' || typeof state !== 'number') {
      return false
    }
    if (targetApi.indexOf(name) == -1) {
      return false
    }
    apiTimes[name].endTime = new Date().getTime()
    apiTimes[name].duration = apiTimes[name].endTime - apiTimes[name].startTime
    apiPostData(state, name)
  },
}
